export const randomImages = [
	"pictures/photo-13.webp",
	"pictures/photo-27.webp",
	"pictures/photo-28.webp",
	"pictures/photo-29.webp",
	"pictures/photo-33.webp",
	"pictures/photo-34.webp",
	"pictures/photo-35.webp",
	"pictures/photo-36.webp",
	"pictures/photo-40.webp",
	"pictures/photo-41.webp",
	"pictures/photo-42.webp",
	"pictures/photo-43.webp",
	"pictures/photo-44.webp",
	"pictures/photo-45.webp",
	"pictures/photo-46.webp",
	"pictures/photo-47.webp",
	"pictures/photo-48.webp",
	"pictures/photo-49.webp",
	"pictures/photo-50.webp",
	"pictures/photo-51.webp",
	"pictures/photo-52.webp",
	"pictures/photo-53.webp",
	"pictures/photo-54.webp",
	"pictures/photo-55.webp",
	"pictures/photo-56.webp",
	"pictures/photo-57.webp",
	"pictures/photo-58.webp",
	"pictures/photo-59.webp",
	"pictures/photo-60.webp",
	"pictures/photo-61.webp",
	"pictures/photo-62.webp",
	"pictures/photo-63.webp",
	"pictures/photo-64.webp",
	"pictures/photo-65.webp",
	"pictures/photo-66.webp",
	"pictures/photo-67.webp",
	"pictures/photo-68.webp",
	"pictures/photo-69.webp",
];
export const comiteMembers = [
	{
		name: "Kendra",
		roles: [
			// "Logística",
			"Redes sociales",
		],
		number: 16,
		image: "16.webp",
	},
	{
		name: "Wendy",
		roles: ["Tesorería"],
		number: 22,
		image: "22.webp",
	},
	{
		name: "Kira",
		roles: ["Gestiones"],
		number: 1,
		image: "1.webp",
	},
	{
		name: "Mariana",
		roles: ["Logística"],
		number: 25,
		image: "25.webp",
	},
];

const path = "/activities";
const ext = ".webp";

export const activities = [
	{ image: "Aniversario", label: "Fiesta de Aniversario", path, ext },
	{ image: "ViajeBCN", label: "Viaje a Barcelona", path, ext },
	{ image: "Friends&Family", label: "Partido Friends & Family", path, ext },
	{ image: "Interclub", label: "Partido Interclub", path, ext },
	{ image: "MadMix", label: "Torneo MadMix", path, ext },
	{ image: "Navidad", label: "Fiesta de Navidad", path, ext },
	{ image: "Viaje", label: "Viaje a Barcelona", path, ext },
	{ image: "Cena", label: "Cena de campeonas", path, ext },
];
export const tecnicMembers = [
	{
		name: "Kira",
		role: "Manager",
		id: "1",
	},
	{
		name: "Alonso",
		role: "Coach",
		id: "Alonso_Tovar",
	},
	{
		name: "Alex",
		role: "Coach",
		id: "Alejandro_Onate",
	},
	{
		name: "Mary Carmen",
		role: "Anotadora",
		id: "MaryCarmen_Lopez",
	},
	{
		name: "Jacky",
		role: "Apoyo",
		id: "Yacky",
	},
];
export const trainingVenues = [
	{
		name: "Lago",
		location: "Paseo Puerta del Ángel 13",
		image: "lago",
		link: "https://goo.gl/maps/1dE79Xxa2GaSgH1t7",
		metro: "línea 10",
		when: "Domingos 11am",
		src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1638.414990066237!2d-3.736015967757012!3d40.41788517524596!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd422915a6c8f697%3A0x5ee300bc9a87e38d!2sCampo%20de%20f%C3%BAtbol!5e0!3m2!1ses!2ses!4v1778235096743!5m2!1ses!2ses",
		// src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3037.6196025828262!2d-3.737715024539755!3d40.41727705560686!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd4229571247ee87%3A0xd2e4d1a3d590946f!2sEspartanas%20Kickingball!5e0!3m2!1ses!2ses!4v1778235007247!5m2!1ses!2ses",
	},
	{
		name: "Vicálvaro",
		location: "Parque de la Maceta",
		image: "vicalvaro",
		link: "https://maps.app.goo.gl/fEEFy9zJhbkRLVXp6",
		metro: "línea 9",
		when: "Martes y jueves 8pm",
		src: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3037.9555762933333!2d-3.6180407!3d40.4098349!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd42254ff28249c7%3A0xfdc582fe18808953!2sCampo%20de%20f%C3%BAtbol!5e0!3m2!1ses!2ses!4v1778233072768!5m2!1ses!2ses",
	},

	// {
	// 	name: 'Colombia',
	// 	location: 'Calle de Puerto Rico 54',
	// 	image: 'pio',
	// 	link: 'https://maps.app.goo.gl/tsgUhQtqwe1L6gbw9',
	// 	metro: 'líneas 8 y 9',
	// 	when: 'Miércoles 8pm',
	// },
	// {
	//     name: 'Príncipe Pío',
	//     location: 'Calle Mozart 25',
	//     image: 'pio',
	//     link: 'https://goo.gl/maps/vChQHsiGxEA1DaY27',
	//     metro: 'líneas 6 y 10',
	//     when: 'Miércoles 7pm',
	// },
	// {
	//     name: 'Pacífico',
	//     location: 'Calle de las Cocheras 5',
	//     image: 'pacifico',
	//     link: 'https://goo.gl/maps/756jmACGS7beJEy29',
	//     metro: 'líneas 1 y 6',
	//     when: 'En caso de lluvia',
	// },
	// {
	// 	name: 'Google Meet',
	// 	// location: 'https://meet.google.com/pps-ogyx-gpn',
	// 	image: 'meet',
	// 	when: 'Remoto',
	// },
];
export const sponsors = [];

export const socialMedia = [
	{
		name: "info@espartanas.com",
		icon: "mail",
		url: "info@espartanas.com",
	},
	{
		name: "Instagram",
		icon: "instagram",
		url: "@espartanaskickingball",
		link: "https://www.instagram.com/espartanaskickingball/",
	},
	{
		name: "Facebook",
		icon: "facebook",
		url: "@espartanaskickingball",
		link: "https://www.facebook.com/EspartanasKickingball",
	},
	{
		name: "Youtube",
		icon: "youtube",
		url: "Espartanas Kickingball",
		link: "https://www.youtube.com/channel/UCmzmsqUUHx2vuUqnoXbSy1w",
	},
];

const pathAddon = "/addons";
const pathMain = "/main";

export const addons = [
	{ image: "circulo", path: pathMain, ext: ".gif" },
	{ image: "bandera", path: pathAddon, ext },
	{ image: "aniversario", path: pathAddon, ext },
	{ image: "gorra", path: pathAddon, ext },
	{ image: "tazas", path: pathAddon, ext },
	{ image: "gafas", path: pathMain, ext },
	{ image: "kira", path: pathMain, ext },
];

export const players = [
	{
		alias: "Kira",
		image: "1.webp",
		number: 1,
	},
	{
		alias: "Veronica",
		image: "2.webp",
		number: 2,
	},
	{
		alias: "Isabella",
		image: "4.webp",
		number: 4,
	},
	{
		alias: "Stefani",
		image: "7.webp",
		number: 7,
	},
	{
		alias: "Desireé",
		image: "8.webp",
		number: 8,
	},
	{
		alias: "Gabriela",
		image: "9.webp",
		number: 9,
	},
	{
		alias: "Willmary",
		image: "10.webp",
		number: 10,
	},
	{
		alias: "Irene",
		image: "13.webp",
		number: 13,
		// driveLink: "1kfS90Y6bbk0q4yxnWDu4KdK8WrV3Xzyk",
	},
	{
		alias: "Kley",
		image: "14.webp",
		number: 14,
	},
	{
		name: "Kendra",
		image: "16.webp",
		number: 16,
		alias: "Kendra",
	},
	{
		alias: "Yenniffer",
		image: "17.webp",
		number: 17,
	},
	{
		alias: "Marly",
		image: "20.webp",
		number: 20,
	},
	{
		alias: "Joeinny",
		image: "21.webp",
		number: 21,
	},
	{
		alias: "Wendy",
		image: "22.webp",
		number: 22,
	},
	// {
	// 	alias: "Yusve",
	// 	image: "24.webp",
	// 	number: 24,
	// },
	{
		alias: "Mariana",
		image: "25.webp",
		number: 25,
	},
	{
		alias: "Mary",
		image: "31.webp",
		number: 31,
	},
	{
		alias: "Meme",
		image: "33.webp",
		number: 33,
	},
	{
		alias: "Andrea",
		image: "37.webp",
		number: 37,
		// driveLink: "1Y-sUMKoscg8vhmD5jBP9ZHx34h5BTjZ4",
	},
	{
		alias: "Neyvi",
		image: "38.webp",
		number: 38,
	},
	{
		alias: "Morella",
		image: "41.webp",
		number: 41,
	},
	{
		alias: "Cots",
		image: "43.webp",
		number: 43,
	},
	{
		alias: "Hayra",
		image: "50.webp",
		number: 50,
	},
	{
		alias: "Angie",
		image: "73.webp",
		number: 73,
	},
];

export const history = [
	// location: "",
	// time: "",
	// score: "",
	// star: "",
	{
		year: 2015,
		folder: "1",
		hito: "Triangular vs Ángeles de Güimar", //"Primer torneo",
		ext: ".webp",
	},
	{
		year: 2016,
		folder: "1",
		location: "Tenerife",
		ext: ".webp",
	},
	{
		year: 2017,
		folder: "1",
		hito: `Torneo "Sin Fronteras"`,
		ext: ".webp",
	},
	{
		year: 2018,
		folder: "1",
		hito: "1ra Liga de Madrid",
		ext: ".webp",
	},
	{
		year: 2019,
		folder: "1",
		location: "Tenerife",
		ext: ".webp",
	},
	{
		year: 2020,
		folder: "1",
		star: "Partido Interclub",
		ext: ".webp",
	},
	{
		year: 2021,
		folder: "1",
		award: "Campeonas 2da Liga",
		ext: ".webp",
	},
	{
		year: 2022,
		folder: "1",
		hito: "MadMix",
		ext: ".webp",
	},
	{
		year: 2023,
		folder: "1",
		hito: "Partido Interclub",
		ext: ".webp",
	},
	{
		year: 2024,
		folder: "1",
		hito: "3er Lugar en 5ta Liga",
		ext: ".webp",
	},
	{
		year: 2025,
		folder: "1",
		award: "Campeonas 6ta Liga",
	},
	{
		year: 2026,
		folder: "1",
		hito: "7ma Liga",
	},
	{
		year: 2015,
		folder: "2",
		star: "Primer Torneo",
		ext: ".webp",
	},
	{
		year: 2016,
		folder: "2",
		hito: "Partido vs Relámpagos",
	},
	{
		year: 2017,
		folder: "2",
		hito: "Partido Amistoso", //vs panteras, mariam",
		ext: ".webp",
	},
	{
		year: 2018,
		folder: "2",
		hito: "1ra Liga",
	},
	{
		year: 2019,
		folder: "2",
		location: "Tenerife",
		ext: ".webp",
	},
	{
		year: 2020,
		folder: "2",
		star: "Partido Interclub",
	},
	{
		year: 2021,
		folder: "2",
		hito: "2da Liga",
		ext: ".webp",
		// star: "Campeonas de la Liga",
	},
	{
		year: 2022,
		folder: "2",
		hito: "3ra Liga",
		ext: ".webp",
	},
	{
		year: 2023,
		folder: "2",
		hito: "4ta Liga",
		ext: ".webp",
	},
	{
		year: 2024,
		folder: "2",
		hito: "Inauguración 5ta Liga",
		ext: ".webp",
	},
	{
		year: 2025,
		folder: "2",
		hito: "6ta Liga",
	},
	{
		year: 2026,
		folder: "2",
		hito: "7ma Liga",
	},
	{
		year: 2015,
		folder: "3",
		hito: "Caimanera navideña",
		ext: ".webp",
	},
	{
		year: 2016,
		folder: "3",
		hito: "Partido vs Ases",
	},
	{
		year: 2017,
		folder: "3",
		hito: "Kickingball sin fronteras",
	},
	{
		year: 2018,
		folder: "3",
		hito: "Partido Amistoso", //vs panteras la elipa o triangular",
	},
	{
		year: 2019,
		folder: "3",
		hito: "Partido Amistoso", //"amisoto vs tropicales",
		ext: ".webp",
	},
	{
		year: 2020,
		folder: "3",
		star: "Entrenamientos virtuales",
		ext: ".webp",
	},
	{
		year: 2021,
		folder: "3",
		award: "Campeonas 2da Liga",
	},
	{
		year: 2022,
		folder: "3",
		hito: "3ra Liga",
		ext: ".webp",
	},
	{
		year: 2023,
		folder: "3",
		hito: "MadMix",
		ext: ".webp",
	},
	{
		year: 2024,
		folder: "3",
		hito: "5ta Liga",
	},
	{
		year: 2025,
		folder: "3",
		award: "Campeonas 6ta Liga",
	},
];

export const historyByYear = [
	[
		{
			year: "2015",
			hito: "Triangular vs Ángeles de Güimar", //"Primer torneo",
			ext: ".webp",
			folder: "1",
		},
		{
			year: "2015",
			folder: "2",
			star: "Primer Torneo",
			ext: ".webp",
		},
		{
			year: "2015",
			folder: "3",
			hito: "Caimanera navideña",
			ext: ".webp",
		},
	],
	[
		{
			year: "2016",
			folder: "1",
			location: "Tenerife",
			ext: ".webp",
		},
		{
			year: "2016",
			folder: "2",
			hito: "Partido vs Relámpagos",
			ext: ".webp",
		},
		{
			year: "2016",
			folder: "3",
			hito: "Partido vs Ases",
		},
	],
	[
		{
			year: "2017",
			folder: "1",
			hito: `Torneo "Sin Fronteras"`,
			ext: ".webp",
		},
		{
			year: "2017",
			folder: "2",
			hito: "Partido Amistoso", //vs panteras, mariam",
			ext: ".webp",
		},
		{
			year: "2017",
			folder: "3",
			hito: "Kickingball sin fronteras",
		},
	],
	[
		{
			year: "2018",
			folder: "1",
			hito: "1ra Liga de Madrid",
			ext: ".webp",
		},
		{
			year: "2018",
			folder: "2",
			hito: "1ra Liga",
		},
		{
			year: "2018",
			folder: "3",
			hito: "Partido Amistoso", //vs panteras la elipa o triangular",
		},
	],
	[
		{
			year: "2019",
			folder: "1",
			location: "Tenerife",
			ext: ".webp",
		},
		{
			year: "2019",
			folder: "2",
			location: "Tenerife",
			ext: ".webp",
		},
		{
			year: "2019",
			folder: "3",
			hito: "Partido Amistoso", //"amisoto vs tropicales",
			ext: ".webp",
		},
	],
	[
		{
			year: "2020",
			folder: "1",
			star: "Partido Interclub",
			ext: ".webp",
		},
		{
			year: "2020",
			folder: "2",
			star: "Partido Interclub",
		},
		{
			year: "2020",
			folder: "3",
			star: "Entrenamientos virtuales",
			ext: ".webp",
		},
	],
	[
		{
			year: "2021",
			folder: "1",
			award: "Campeonas 2da Liga",
			ext: ".webp",
		},
		{
			year: "2021",
			folder: "2",
			hito: "2da Liga",
			ext: ".webp",
			// star: "Campeonas de la Liga",
		},
		{
			year: "2021",
			folder: "3",
			award: "Campeonas 2da Liga",
		},
	],
	[
		{
			year: "2022",
			folder: "1",
			hito: "MadMix",
			ext: ".webp",
		},
		{
			year: "2022",
			folder: "2",
			hito: "3ra Liga",
			ext: ".webp",
		},
		{
			year: "2022",
			folder: "3",
			hito: "3ra Liga",
			ext: ".webp",
		},
	],
	[
		{
			year: "2023",
			folder: "1",
			hito: "Partido Interclub",
			ext: ".webp",
		},
		{
			year: "2023",
			folder: "2",
			hito: "4ta Liga",
			ext: ".webp",
		},
		{
			year: "2023",
			folder: "3",
			hito: "MadMix",
			ext: ".webp",
		},
	],
	[
		{
			year: "2024",
			folder: "1",
			hito: "3er Lugar en 5ta Liga",
			ext: ".webp",
		},
		{
			year: "2024",
			folder: "2",
			hito: "Inauguración 5ta Liga",
			ext: ".webp",
		},
		{
			year: "2024",
			folder: "3",
			hito: "5ta Liga",
		},
	],
	[
		{
			year: "2025",
			folder: "1",
			award: "Campeonas 6ta Liga",
		},
		{
			year: "2025",
			folder: "2",
			hito: "6ta Liga",
		},
		{
			year: "2025",
			folder: "3",
			award: "Campeonas 6ta Liga",
		},
	],
	[
		{
			year: "2026",
			folder: "1",
			hito: "7ma Liga",
		},
		{
			year: "2026",
			folder: "2",
			hito: "7ma Liga",
		},
		{
			year: "2026",
			folder: "3",
			hito: "7ma Liga",
		},
	],
];

export const historyByYear2 = [
	[
		{
			year: "2015",
			hito: "Triangular vs Ángeles de Güimar", //"Primer torneo",
			ext: ".webp",
		},
		{
			year: "2015",
			star: "Primer Torneo",
			ext: ".webp",
		},
	],
	[
		{
			year: "2016",
			hito: "Partido vs Ases",
			ext: ".webp",
		},
		{
			year: "2016",
			location: "Tenerife",
			ext: ".webp",
		},
	],
	[
		{
			year: "2017",
			hito: "Kickingball sin fronteras",
			ext: ".webp",
		},
		{
			year: "2017",
			hito: `Torneo "Sin Fronteras"`,
			ext: ".webp",
		},
	],
	[
		{
			year: "2018",
			hito: "1ra Liga de Madrid",
			ext: ".webp",
		},
		{
			year: "2018",
			hito: "1ra Liga",
			ext: ".webp",
		},
	],

	[
		{
			year: "2019",
			location: "Tenerife",
			ext: ".webp",
		},
		{
			year: "2019",
			hito: "Partido Amistoso", //"amisoto vs tropicales",
			ext: ".webp",
		},
	],
	[
		{
			year: "2020",
			star: "Entrenamientos virtuales",
			ext: ".webp",
		},
		{
			year: "2020",
			star: "Partido Interclub",
			ext: ".webp",
		},
	],
	[
		{
			year: "2021",
			award: "Campeonas 2da Liga",
			ext: ".webp",
		},
		{
			year: "2021",
			award: "Campeonas 2da Liga",
			ext: ".webp",
		},
	],
	[
		{
			year: "2022",
			hito: "3ra Liga",
			ext: ".webp",
		},
		{
			year: "2022",
			hito: "3ra Liga",
			ext: ".webp",
		},
	],
	[
		{
			year: "2023",
			hito: "4ta Liga",
			ext: ".webp",
		},
		{
			year: "2023",
			hito: "MadMix",
			ext: ".webp",
		},
	],
	[
		{
			year: "2024",
			hito: "Inauguración 5ta Liga",
			ext: ".webp",
		},
		{
			year: "2024",
			hito: "5ta Liga",
			ext: ".webp",
		},
	],
	[
		{
			year: "2025",
			hito: "6ta Liga",
			ext: ".webp",
		},
		{
			year: "2025",
			award: "Campeonas 6ta Liga",
			ext: ".webp",
		},
	],
	[
		{
			year: "2026",
			hito: "7ma Liga",
			ext: ".webp",
		},
		{
			year: "2026",
			hito: "7ma Liga",
			ext: ".webp",
		},
	],
];

export const trainingVideos = [
	{
		shortId: "ZIvG5eKCFWc",
	},
	{
		shortId: "-1x_rMa1a34",
	},
	{
		shortId: "7w4CIvih6YY",
	},
	{
		shortId: "XmhSQplf_2Q",
	},
	{
		shortId: "uQrbozzC0lg",
	},
	{
		shortId: "CBPhbxj_GZk",
	},
	{
		shortId: "LAhxGYyXDG4",
	},
];
